<template>
    <el-card class="box-card">
        <div class="component-content">
            <el-dialog
                title="信息更新结果"
                :visible.sync="resultShow"
                width="50%" lock-scroll
                center
            >
                <el-table :data="resultArray"
                          row-key="id + '_' + server_url"
                          stripe
                          style="width: 100%;"
                          :default-sort="{prop: 'id'}"
                >
                    <el-table-column prop="server_name" label='服务器名' width="160" fixed></el-table-column>
                    <el-table-column prop="server_url" label='请求地址' width="500"></el-table-column>
                    <el-table-column prop="resStatus" label='响应结果' width="150"></el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="resultShow = false">关闭</el-button>
                </div>
            </el-dialog>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全服邮件查询" name="first">
                    <section class="content">
                        <div class="query-panel">
                            <el-form :inline="true">
                                <el-form-item>
                                    <el-button size="small" type="danger" @click="dotTipsPush">邮件红点推送</el-button>
                                    <div>推送前先确认全服邮件已生效且对全服玩家有效</div>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table :data="rawData"
                                  row-key=" id"
                                  border
                                  stripe
                                  style="margin-top:20px;width: 100%"
                                  :default-sort="{prop: 'id'}"
                        >
                            <el-table-column prop="uniqueId" label="唯一编号"></el-table-column>
                            <el-table-column label="当前状态" width="100">
                                <template slot-scope="scope">
                                    <template v-if="timeZoneValue == 8">
                                        <span v-if="(new Date().getTime()) < (new Date(scope.row.gmtStarted).getTime())">
                                        未发送
                                        </span>
                                            <span style="color: gray;" v-if="(new Date().getTime()) > (new Date(scope.row.gmtDisabled).getTime())">
                                            已失效
                                        </span>
                                            <span style="color: green;" v-if="(new Date().getTime()) >= (new Date(scope.row.gmtStarted).getTime()) && (new Date().getTime()) < (new Date(scope.row.gmtDisabled).getTime())">
                                            生效中
                                        </span>
                                    </template>
                                    <template v-if="timeZoneValue == -5">
                                        <span v-if="(toWest5Time(new Date()).getTime()) < (new Date(scope.row.gmtStarted).getTime())">
                                        未发送
                                        </span>
                                        <span style="color: gray;" v-if="(toWest5Time(new Date()).getTime()) > (new Date(scope.row.gmtDisabled).getTime())">
                                            已失效
                                        </span>
                                        <span style="color: green;" v-if="(toWest5Time(new Date()).getTime()) >= (new Date(scope.row.gmtStarted).getTime()) && (toWest5Time(new Date()).getTime()) < (new Date(scope.row.gmtDisabled).getTime())">
                                            生效中
                                        </span>
                                    </template>
                                </template>
                            </el-table-column>
                            <el-table-column label="邮件标题">
                                <template slot-scope="props">
                                    <div v-for="(value,key) in JSON.parse(props.row.content)" :key="key" v-if="key ==  'title'">
                                        <template v-for="(title,titleKey) in value">
                                            <div v-if="title && title !== '' && titleKey == 'zh-Hans'">简中:{{title}}</div>
                                            <div v-if="title && title !== '' && titleKey == 'zh-Hant'">繁中:{{title}}</div>
                                            <div v-if="title && title !== '' && titleKey == 'ja-JP'">日文:{{title}}</div>
                                            <div v-if="title && title !== '' && titleKey == 'ko-KR'">韩文:{{title}}</div>
                                            <div v-if="title && title !== '' && titleKey == 'ru-RU'">俄文:{{title}}</div>
                                            <div v-if="title && title !== '' && titleKey == 'en-US'">英文:{{title}}</div>
                                        </template>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="发件人">
                                <template slot-scope="props">
                                    <div v-for="(value,key) in JSON.parse(props.row.content)" :key="key" v-if="key ==  'sender'">
                                        <template v-for="(sender,senderKey) in value">
                                            <div v-if="sender && sender !== '' && senderKey == 'zh-Hans'">简中:{{sender}}</div>
                                            <div v-if="sender && sender !== '' && senderKey == 'zh-Hant'">繁中:{{sender}}</div>
                                            <div v-if="sender && sender !== '' && senderKey == 'ja-JP'">日文:{{sender}}</div>
                                            <div v-if="sender && sender !== '' && senderKey == 'ko-KR'">韩文:{{sender}}</div>
                                            <div v-if="sender && sender !== '' && senderKey == 'ru-RU'">俄文:{{sender}}</div>
                                            <div v-if="sender && sender !== '' && senderKey == 'en-US'">英文:{{sender}}</div>
                                        </template>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="disableDays" label="有效期（领取后多久失效）" width="100"></el-table-column>
                            <el-table-column prop="rewardVal" label="奖励" width="190"></el-table-column>
                            <el-table-column  prop="gmtStarted"  label="开启时间" width="160"></el-table-column>
                            <el-table-column prop="gmtDisabled" label="结束时间" width="160"></el-table-column>
                            <!--                            <el-table-column prop="" label="发送原因"></el-table-column>-->
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="showGlobalMailDetail(scope.row)">详情</el-button>

                                    <template v-if="timeZoneValue == 8">
                                        <span v-if="(new Date().getTime()) < (new Date(scope.row.gmtStarted).getTime()) ||
                                        (new Date().getTime()) >= (new Date(scope.row.gmtStarted).getTime()) && (new Date().getTime()) < (new Date(scope.row.gmtDisabled).getTime())">
                                           <el-button type="text" @click="stopGlobalMail(scope.row)">停止发送</el-button>
                                        </span>
                                    </template>
                                    <template v-if="timeZoneValue == -5">
                                        <span v-if="(toWest5Time(new Date()).getTime()) < (new Date(scope.row.gmtStarted).getTime()) ||
                                        (toWest5Time(new Date()).getTime()) >= (new Date(scope.row.gmtStarted).getTime()) && (toWest5Time(new Date()).getTime()) < (new Date(scope.row.gmtDisabled).getTime())">
                                           <el-button type="text" @click="stopGlobalMail(scope.row)">停止发送</el-button>
                                        </span>
                                    </template>

                                </template>
                            </el-table-column>
                        </el-table>
                        <el-dialog title='全服邮件详情' :visible.sync="previewDateShow" width="50%" lock-scroll center>
                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>基础信息</span>
                                </div>
                                <el-form label-position="left" label-width="100px">
                                    <el-form-item label="唯一编号:">{{ dialogData.uniqueId }}</el-form-item>
                                    <el-form-item label="创建时间:">{{ dialogData.gmtCreate }}</el-form-item>
                                    <el-form-item label="有效天数:">{{ dialogData.disableDays }}</el-form-item>
                                </el-form>
                            </el-card>
                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>触发条件</span>
                                </div>
                                <el-form label-position="left" label-width="100px">
                                    <el-form-item label="可领取渠道:">{{ dialogData.server==0?'全服': dialogData.server }}</el-form-item>
                                    <el-form-item label="可领取时间:">{{ dialogData.gmtStarted }} - {{ dialogData.gmtDisabled }}</el-form-item>
                                    <el-form-item label="其他条件:">
                                        <div v-for="(value,key) in dialogData.conditionJsonDetail">
                                            <span v-if="key == 'channel'">渠道</span>
                                            <span v-if="key == 'version'">版本</span>
                                            <span v-if="key == 'userLevel'">用户等级</span>
                                            <span v-if="key == 'userRegisterTime'">用户注册时间</span>
                                            <span>: {{value}}</span>
                                        </div>
                                    </el-form-item>
                                </el-form>
                            </el-card>

                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>邮件信息</span>
                                </div>
                                <el-form label-position="left" label-width="100px">
                                    <el-form-item label="内容:" v-if="dialogData.content">
                                        <div v-for="(value,key) in JSON.parse(dialogData.content)" :key="key" v-if="key ==  'content'">
                                            <template v-for="(content,contentKey) in value">
                                                <div v-if="content && content.length > 0 && contentKey == 'zh-Hans'">简中:{{content}}</div>
                                                <div v-if="content && content.length > 0 && contentKey == 'zh-Hant'">繁中:{{content}}</div>
                                                <div v-if="content && content.length > 0 && contentKey == 'ja-JP'">日文:{{content}}</div>
                                                <div v-if="content && content.length > 0 && contentKey == 'ko-KR'">韩文:{{content}}</div>
                                                <div v-if="content && content.length > 0 && contentKey == 'ru-RU'">俄文:{{content}}</div>
                                                <div v-if="content && content.length > 0 && contentKey == 'en-US'">英文:{{content}}</div>
                                            </template>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="奖励:">{{ dialogData.rewardVal }}</el-form-item>
                                </el-form>
                            </el-card>

                            <template v-if="timeZoneValue == 8">
                                <el-card v-if="!((new Date().getTime()) > (new Date(dialogData.gmtDisabled).getTime()))">
                                    <div slot="header" class="clearfix">
                                        <span>可修改信息</span>
                                    </div>
                                    <el-form label-position="left" label-width="100px">
                                        <el-form-item label="结束时间:">
                                            <el-date-picker v-model="dialogData.gmtDisabled" type="datetime" @change="getDialogDataGmtDisabled()"
                                                            placeholder="选择日期"
                                                            :picker-options="pickerOptionsStart"
                                                            value-format="yyyy-MM-dd HH:mm:ss">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-form>
                                </el-card>
                            </template>
                            <template v-if="timeZoneValue == -5">
                                <el-card v-if="!((toWest5Time(new Date()).getTime()) > (new Date(dialogData.gmtDisabled).getTime()))">
                                    <div slot="header" class="clearfix">
                                        <span>可修改信息</span>
                                    </div>
                                    <el-form label-position="left" label-width="100px">
                                        <el-form-item label="时区：">
                                            <el-select v-model="localZoneTime2">
                                                <el-option
                                                    v-for="localZoneTimeItem in localZoneTimeOptions"
                                                    :key="localZoneTimeItem.value"
                                                    :value="localZoneTimeItem.value"
                                                    :label="localZoneTimeItem.label">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="结束时间:">
                                            <el-date-picker v-model="localDialogDataGmtDisabled" type="datetime" @change="getDialogDataGmtDisabled()"
                                                            placeholder="选择日期"
                                                            :picker-options="pickerOptionsStart"
                                                            value-format="yyyy-MM-dd HH:mm:ss">
                                            </el-date-picker>
                                            <template v-if="localDialogDataGmtDisabled">
                                                <span class="mail-tip">本地时间:{{localDialogDataGmtDisabled2}}(utc{{localZoneTime2}})</span>
                                                <span>||</span>
                                                <span class="mail-tip">服务器时间:{{dialogData.gmtDisabled}}(utc{{serverZoneTime}})</span>
                                            </template>
                                        </el-form-item>
                                    </el-form>
                                </el-card>
                            </template>


                            <div slot="footer" class="dialog-footer">
                                <template v-if="timeZoneValue == 8">
                                    <el-button type="primary" v-if="!((new Date().getTime()) > (new Date(dialogData.gmtDisabled).getTime()))" @click="modifyGlobalMail()">修改结束时间</el-button>
                                </template>
                                <template v-if="timeZoneValue == -5">
                                    <el-button type="primary" v-if="!((toWest5Time(new Date()).getTime()) > (new Date(dialogData.gmtDisabled).getTime()))" @click="modifyGlobalMail()">修改结束时间</el-button>
                                </template>

                                <el-button @click="cancelGlobalMailDetailDialog()">关闭详情</el-button>
                            </div>
                        </el-dialog>
                    </section>
                </el-tab-pane>
                <el-tab-pane label="全服邮件发送" name="second">

                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>邮件奖励领取失效期</span>
                        </div>
                        <el-input-number v-model="endTime" :min="1" :max="100"></el-input-number>
                        <span>天</span>
                        <template>
                            <span>快捷选项：</span>
                            <el-button size="mini" @click="endTime = 7">一周后</el-button>
                            <el-button size="mini" @click="endTime = 14">二周后</el-button>
                            <el-button size="mini" @click="endTime = 30">一个月后</el-button>
                            <el-button size="mini" @click="endTime = 90">三个月后</el-button>
                        </template>
                    </el-card>

                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>收件人</span>
                        </div>

                        <el-form label-suffix=":">
                            <el-form-item label="选服模式">
                                <el-select v-model="selectMode">
                                    <el-option v-for="item in selectOption" :key="item.id"
                                               :label="item.lang"
                                               :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="当前对外开放的服务器" v-if="selectMode === 'currentOpen'">
                                <span v-for="item in loginInfoGame" :key="'server' + item.id"
                                      v-if="item.server_load !== 4 && item.server_load !== 4">
                                            {{item.server_number}}({{item.server_name}}),
                                </span>
                            </el-form-item>
                            <el-form-item label="当前已配置的服务器" v-if="selectMode === 'currentAll'">
                                <span v-for="item in loginInfoGame" :key="'server' + item.id">
                                            {{item.server_number}}({{item.server_name}}),
                                </span>
                            </el-form-item>
                            <el-form-item v-if="selectMode === 'serverArray'">
                                <component-server @gameValue="getGameValue" :serverMode="'mode_game'"></component-server>
                            </el-form-item>
                        </el-form>

                        <!--                        <el-switch
                                                    style="margin: 10px 0;"
                                                    v-model="isSelectServer"
                                                    active-color="#13ce66"
                                                    inactive-color="#ff4949"
                                                    active-text="选服"
                                                    inactive-text="全服">
                                                </el-switch>-->



                        <el-form label-suffix=":">
                            <el-form-item label="条件">
                                <el-button type="primary" @click="addCustomLimit">添加条件</el-button>
                            </el-form-item>
                            <el-form-item label="">
                                <div v-for="(item,index) in customLimitData" :key="index">
                                    <span>条件{{index+1}}:</span>

                                    <el-select v-model="customLimitData[index].optionSelected" @change="optionChange">
                                        <el-option
                                            v-for="itemOptions in customLimitOptions"
                                            :key="itemOptions.value"
                                            :value="itemOptions.value"
                                            :label="itemOptions.label"
                                            :disabled="getCustomLimitDisable(itemOptions.value)">
                                        </el-option>
                                    </el-select>

                                    <template v-if="customLimitData[index].optionSelected == 'channel'">
                                        <span>渠道:</span>
                                        <el-select v-model="item.channel" multiple>
                                            <el-option
                                                v-for="channelItem in channelData"
                                                :key="channelItem.value"
                                                :value="channelItem.value.toString()"
                                                :label="channelItem.value + '(' + channelItem.channel + ')'">
                                            </el-option>
                                        </el-select>
                                    </template>
                                    <template v-if="customLimitData[index].optionSelected == 'version'">
                                        <span>版本:</span>
                                        <el-input v-model="item.version" style="width: 100px"></el-input>
                                    </template>
                                    <template v-if="customLimitData[index].optionSelected == 'userLevel'">
                                        <span>用户等级:</span>
                                        <el-input v-model="item.userLevel" placeholder="格式为min_max" style="width: 130px;"></el-input>
                                    </template>
                                    <template v-if="customLimitData[index].optionSelected == 'userRegisterTime'">
                                        <span>时区:</span>
                                        <el-select v-model="localZoneTime3">
                                            <el-option
                                                v-for="localZoneTimeItem in localZoneTimeOptions"
                                                :key="localZoneTimeItem.value"
                                                :value="localZoneTimeItem.value"
                                                :label="localZoneTimeItem.label">
                                            </el-option>
                                        </el-select>
                                        <span>用户注册时间:</span>
                                        <el-date-picker v-model="item.localUserRegisterTime" type="datetimerange" @change="getUserRegisterTime(index)"
                                                        placeholder="选择日期" value-format="timestamp" format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions">
                                        </el-date-picker>
                                        <template v-if="item.localUserRegisterTime">
                                            <span class="mail-tip">本地时间:{{localUserRegisterTimeStart2}}至{{localUserRegisterTimeEnd2}}(utc{{localZoneTime3}})</span>
                                            <span>||</span>
                                            <span class="mail-tip">服务器时间:{{localUserRegisterTimeStart}}至{{localUserRegisterTimeEnd}}(utc{{serverZoneTime}})</span>
                                        </template>
                                    </template>

                                    <el-button type="danger" icon="el-icon-delete" circle @click="delCustomLimit(index)"></el-button>
                                </div>
                            </el-form-item>
                        </el-form>

                        <!--<el-switch-->
                        <!--style="margin: 20px 0;"-->
                        <!--v-model="isOpenWhite"-->
                        <!--active-color="#13ce66"-->
                        <!--inactive-color="#ff4949"-->
                        <!--active-text="开放白名单"-->
                        <!--inactive-text="正常">-->
                        <!--</el-switch>-->

                    </el-card>

                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>发送时间区间</span>
                        </div>
                        <el-form>
                            <el-form-item label="时区：">
                                <el-select v-model="localZoneTime">
                                    <el-option
                                        v-for="localZoneTimeItem in localZoneTimeOptions"
                                        :key="localZoneTimeItem.value"
                                        :value="localZoneTimeItem.value"
                                        :label="localZoneTimeItem.label">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="起始时间：">
                                <el-date-picker v-model="localGmtStarted" type="datetime" @change="getGmtStarted()"
                                                placeholder="选择日期"
                                                :picker-options="pickerOptionsStart" value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                                <template v-if="localGmtStarted">
                                    <span class="mail-tip">本地时间:{{localGmtStarted2}}(utc{{localZoneTime}})</span>
                                    <span>||</span>
                                    <span class="mail-tip">服务器时间:{{mailGlobalSendForm.gmtStarted}}(utc{{serverZoneTime}})</span>
                                </template>
                            </el-form-item>
                            <el-form-item label="结束时间：">
                                <el-date-picker v-model="localGmtDisabled" type="datetime" @change="getGmtDisabled()"
                                                placeholder="选择日期"
                                                :picker-options="pickerOptionsDisabled" value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                                <template v-if="localGmtDisabled">
                                    <span class="mail-tip">本地时间:{{localGmtDisabled2}}(utc{{localZoneTime}})</span>
                                    <span>||</span>
                                    <span class="mail-tip">服务器时间:{{mailGlobalSendForm.gmtDisabled}}(utc{{serverZoneTime}})</span>
                                </template>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <mail-editor
                        mailType="global_mail"
                        :mailTemplateContent="mailTemplateContent"
                        :showTemplate="true"
                        :confirmSendMail="confirmSendMail"
                        @mailContent="getMailContent"
                        @rewardsStr="getRewardsStr"
                        :templateType="'common'">
                    </mail-editor>

                    <el-button type="primary" @click="showPostMail">发送</el-button>

                    <el-dialog title='发送邮件' :visible.sync="postMailShow" width="50%" lock-scroll center>
                        <div>
                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>邮件内容</span>
                                </div>

                                <el-tabs v-model="editableTabsValue" type="card">
                                    <el-tab-pane
                                        v-for="(item2, index2) in langType"
                                        :key="item2.id"
                                        :label="item2.label"
                                        :name="item2.val"
                                    >
                                        <template v-for="(value, key) in langGroups" v-if ="item2.val == key">
                                            <el-card>
                                                <el-form label-position="left" label-width="60px">
                                                    <el-form-item label='标题'>
                                                        {{value.title}}
                                                    </el-form-item>
                                                    <el-form-item label='发件人'>
                                                        {{value.sender}}
                                                    </el-form-item>
                                                    <el-form-item label='内容'>
                                                        <!--<div style="background-color: #233858;" v-html="value.contentHtml"></div>-->
                                                        <div style="background-color: #89CFF0;" v-html="value.contentHtml"></div>
                                                    </el-form-item>
                                                </el-form>
                                            </el-card>
                                        </template>
                                    </el-tab-pane>
                                </el-tabs>
                            </el-card>

                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>最终奖励串</span>
                                </div>

                                <div v-if="rewardsStr!==''">{{rewardsStr}}({{rewardsStrCN}})</div>
                            </el-card>
                        </div>
                        <div slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="sendGlobalMail" v-if="!isSendSuccess">发送</el-button>
                            <el-button class="rainbow-btn" type="primary" @click="postMailShow = false" v-if="isSendSuccess">发送成功，关闭窗口</el-button>
                        </div>
                    </el-dialog>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-card>
</template>

<script>
    import mailApi from '../../service/mail_api'
    import worldApi from '../../service/world_api'
    import gameApi from '../../service/game_api'
    import configSettingApi from '../../service/config_setting_api'
    import actionConfirm from '../../mixins/action_confirm'
    import lang_config from '../../data/lang_config.json'
    import {
        mapState
    } from 'vuex';
    import mailEditor from '../../components/mail_editor'
    import componentQuery from '../../components/component_query'
    import componentServer from '../../components/component_server'
    import commonApi from "../../service/common_api";
    import Utils from "../../lib/utils";

    export default {
        name: "global_mail",
        data() {
            return {
                serverZoneTime: Global_Config_Yunwei.serverZoneTime,
                localZoneTime: 8,
                localZoneTime2: 8,
                localZoneTime3: 8,
                localZoneTimeOptions: [
                    {
                        label: 'utc8',
                        value: 8
                    },
                    {
                        label: 'utc-5',
                        value: -5
                    }
                ],
                title: this.$route.meta.title,
                Utils:Utils,
                langOptions: lang_config,
                activeName: "first",
                endTime: 30,
                previewDateShow: false,
                dialogData: {},
                localDialogDataGmtDisabled: '',
                localDialogDataGmtDisabled2: '',
                resultShow:false,
                resultArray:[],
                // 全服邮件发送对象
                rawData:[],
                mailGlobalSendForm: {
                    disableDays: '',
                    mailContents: [],
                    conditionMap: [],
                    rewards: '',
                    status: '1',
                    server: '0',
                    gmtStarted: '',
                    gmtDisabled: ''
                },
                localGmtStarted: '',
                localGmtStarted2: '',
                localGmtDisabled: '',
                localGmtDisabled2: '',

                loginInfoGame:[],
                loginInfoWorld:[],
                langGroups: [],
                rewardsStr: '',

                mailTemplateContent: {
                    'zh-Hans': {title: "", sender: "", content: [], contentHtml: ""},
                    'zh-Hant': {title: "", sender: "", content: [], contentHtml: ""},
                    'ja-JP': {title: "", sender: "", content: [], contentHtml: ""},
                    'ko-KR': {title: "", sender: "", content: [], contentHtml: ""},
                    'ru-RU': {title: "", sender: "", content: [], contentHtml: ""},
                    'en-US': {title: "", sender: "", content: [], contentHtml: ""}
                },
                pickerOptionsStart: {
                    disabledDate(time) {
                        return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
                    },
                    shortcuts: [
                        {
                            text: '明天',
                            onClick(picker) {
                                const date = new Date();
                                date.setTime(date.getTime() + 3600 * 1000 * 24);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '三天后',
                            onClick(picker) {
                                const date = new Date();
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '一周后',
                            onClick(picker) {
                                const date = new Date();
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '一个月后',
                            onClick(picker) {
                                const date = new Date();
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', date);
                            }
                        }
                    ]
                },

                playerQueryMode: ['mode_file_id_str','mode_file_id'],

                selectOption:[
                    {
                        id:'totalAll',
                        lang:'全服1（包含未配置的服务器）'
                    },
                    {
                        id:'currentAll',
                        lang:'全服2（当前已配置的全部服务器）'
                    },
                    {
                        id:'currentOpen',
                        lang:'全服3（已对外开放的服务器）'
                    },
                    {
                        id:'serverArray',
                        lang:'手动选服'
                    }
                ],
                selectMode:'currentOpen',

                isSelectServer: false,
                isOpenWhite: false,
                // 已选游戏服数据
                gameServerStr: '',
                gameServerData: [],

                playerServerStr: '',

                confirmSendMail: false,
                // 是否发送成功
                isSendSuccess: false,

                postMailShow: false,
                editableTabsValue: '',
                rewardsStrCN: '',

                optionMap:{
                    '0':this.$t("reward_editor.39"),
                    '1':this.$t("reward_editor.40"),
                    '2':this.$t("reward_editor.41"),
                    '3':this.$t("reward_editor.42"),
                    '4':this.$t("reward_editor.43"),
                    '5':'约束性道具',
                    '6':this.$t("reward_editor.44"),
                    '7':'战纹',
                    '8':this.$t("reward_editor.46"),
                    '9':this.$t("reward_editor.47"),
                    '10':'回复类道具',
                    '11':'头像',
                    '12':'头像框',
                    '13':'宝箱',
                    '14':'皮肤',
                    '15':'时效类道具',
                    '16':'部落头像',
                    '17':'起源盘',
                    '18':'自选元核',
                    '19':'进化光谱',
                    '20':'聊天框',
                    '21':'战斗框',
                    '22':'元核碎片',
                    '23':'元核髓',
                },
                optionValue: '0',
                count1: '',
                count2: '',
                countSwitch: false,
                rate: 0.1,
                value: '',
                emblemEntryConfigs: [],
                emblemLevel: 1,
                emblemStage: 0,
                emblemQuality: 1,
                emblemFate:0,
                emblemFateCustomizeTags:[],
                emblemFateCustomize:100,
                emblemMainProperty: 1,
                emblemFateProperty: 51,
                editEmblemEntries:[
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ],

                // 条件数据
                customLimitData: [],
                localUserRegisterTimeStart: '',
                localUserRegisterTimeStart2: '',
                localUserRegisterTimeEnd: '',
                localUserRegisterTimeEnd2: '',

                customLimitOptions: [
                    {
                        label: '渠道',
                        value: 'channel'
                    },
                    {
                        label: '版本',
                        value: 'version'
                    },
                    {
                        label: '用户等级',
                        value: 'userLevel'
                    },
                    {
                        label: '用户注册时间',
                        value: 'userRegisterTime'
                    },
                ],
                customLimitSelectedOptions: [],

                // 渠道列表
                channelData: [],

                pickerOptions: {
                    shortcuts: [
                        {
                            text: '此刻',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '一键填入时间',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date('2023-12-01 00:00:00');
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                },

                timeZoneValue: '8'
            }
        },
        mixins: [actionConfirm],
        watch: {
        },
        created() {
            this.loadGlobalMail();
            this.getChannelsList();
            this.loadActivityInfo();
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
                serverWorldList: state => state.server.serverWorldList,
            }),
            pickerOptionsDisabled() {
                return {
                    disabledDate(time) {
                        return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
                    },
                    shortcuts: [
                        {
                            text: '明天',
                            onClick: (picker) => {
                                let gmtStarted = this.localGmtStarted;
                                const date = new Date(gmtStarted);
                                date.setTime(date.getTime() + 3600 * 1000 * 24);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '三天后',
                            onClick: (picker) => {
                                let gmtStarted = this.localGmtStarted;
                                const date = new Date(gmtStarted);
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '一周后',
                            onClick: (picker) => {
                                let gmtStarted = this.localGmtStarted;
                                const date = new Date(gmtStarted);
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '一个月后',
                            onClick: (picker) => {
                                let gmtStarted = this.localGmtStarted;
                                const date = new Date(gmtStarted);
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', date);
                            }
                        }
                    ]

                }
            },
        },
        mounted() {
            this.getLangs();

            setTimeout(() => {
                let langInCookie = Utils.getCookie('lang');
                this.$i18n.locale = langInCookie;
                this.langType.forEach(conf => {
                    if (conf.value == langInCookie) {
                        this.editableTabsValue = conf.val;
                    }
                });
            },2000)

            this.timeZoneValue = this.serverZoneTime?this.serverZoneTime:'8';
        },
        methods: {
            getGmtStarted() {
                let self = this;
                const date = new Date(self.localGmtStarted);

                let localTime = '';
                let localTimeZone = self.localZoneTime;

                localTime = date;
                self.localGmtStarted2 = Utils.formatDate(localTime);

                let time = '';
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time = localTime;
                    } else if (timeZone == 8) {
                        time = self.west5TimeToEast8Time(date)
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time = self.toWest5Time(date)
                    } else if (timeZone == 8) {
                        time = localTime;
                    }
                }

                self.mailGlobalSendForm.gmtStarted = Utils.formatDate(time);
            },

            getGmtDisabled() {
                let self = this;
                const date = new Date(self.localGmtDisabled);

                let localTime = '';
                let localTimeZone = self.localZoneTime;

                localTime = date;
                self.localGmtDisabled2 = Utils.formatDate(localTime);

                let time = '';
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time = localTime;
                    } else if (timeZone == 8) {
                        time = self.west5TimeToEast8Time(date)
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time = self.toWest5Time(date)
                    } else if (timeZone == 8) {
                        time = localTime;
                    }
                }

                self.mailGlobalSendForm.gmtDisabled = Utils.formatDate(time);
            },

            getDialogDataGmtDisabled() {
                let self = this;
                const date = new Date(self.localDialogDataGmtDisabled);

                let localTime = '';
                let localTimeZone = self.localZoneTime2;

                localTime = date;
                self.localDialogDataGmtDisabled2 = Utils.formatDate(localTime);

                let time = '';
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time = localTime;
                    } else if (timeZone == 8) {
                        time = self.west5TimeToEast8Time(date)
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time = self.toWest5Time(date)
                    } else if (timeZone == 8) {
                        time = localTime;
                    }
                }

                self.dialogData.gmtDisabled = Utils.formatDate(time);
            },

            getUserRegisterTime(index) {
                let self = this;
                const date = self.customLimitData[index].localUserRegisterTime;

                let localTime = '';
                let localTimeZone = self.localZoneTime3;

                localTime = date;
                self.localUserRegisterTimeStart2 = Utils.formatDate(localTime[0]);
                self.localUserRegisterTimeEnd2 = Utils.formatDate(localTime[1]);

                let time = [];
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time[0] = new Date(localTime[0]).getTime();
                        time[1] = new Date(localTime[1]).getTime();
                        self.localUserRegisterTimeStart = Utils.formatDate(new Date(localTime[0]));
                        self.localUserRegisterTimeEnd = Utils.formatDate(new Date(localTime[1]));
                    } else if (timeZone == 8) {
                        time[0] = self.west5TimeToEast8Time(new Date(date[0])).getTime();
                        time[1] = self.west5TimeToEast8Time(new Date(date[1])).getTime();
                        self.localUserRegisterTimeStart = Utils.formatDate(self.west5TimeToEast8Time(new Date(date[0])));
                        self.localUserRegisterTimeEnd = Utils.formatDate(self.west5TimeToEast8Time(new Date(date[1])));
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time[0] = self.toWest5Time(new Date(date[0])).getTime();
                        time[1] = self.toWest5Time(new Date(date[1])).getTime();
                        self.localUserRegisterTimeStart = Utils.formatDate(self.toWest5Time(new Date(date[0])));
                        self.localUserRegisterTimeEnd = Utils.formatDate(self.toWest5Time(new Date(date[1])));
                    } else if (timeZone == 8) {
                        time[0] = new Date(localTime[0]).getTime();
                        time[1] = new Date(localTime[1]).getTime();
                        self.localUserRegisterTimeStart = Utils.formatDate(new Date(localTime[0]));
                        self.localUserRegisterTimeEnd = Utils.formatDate(new Date(localTime[1]));
                    }
                }

                self.customLimitData[index].userRegisterTime = time;
            },

            handleClick(tab, event) {
                if (tab.name === 'first') {
                    this.loadGlobalMail();
                    this.timeZoneValue = this.serverZoneTime?this.serverZoneTime:'8';
                }
            },
            loadGlobalMail(){
                let self = this;
                mailApi.findAllSystemMails({
                    token: self.token
                }).then(res => {
                    self.rawData =[];
                    res.forEach(item=>{
                        item.rewardVal = item.rewards + (item.rewards?'(':'') + self.formatterRewardsToCN(item.rewards) + (item.rewards?')':'')
                        self.rawData.push(item);
                    })
                })
            },

            loadActivityInfo() {
                let self = this;
                commonApi.getConfs({
                    tables: 'login_info_game,login_info_world'
                }).then(res => {
                    let sourceGameInfo = res.login_info_game;
                    this.loginInfoGame = [];
                    let subGameInfo = [];
                    for (let tmpItem of sourceGameInfo) {
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoGame.push(tmpItem);
                        } else {
                            subGameInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subGameInfo) {
                        this.loginInfoGame.forEach(mainGameServer => {
                            if (tmpItem.combine_server_number === mainGameServer.server_number) {
                                mainGameServer.children.push(tmpItem);
                            }
                        })
                    }

                    this.loginInfoGame.sort((a, b) => {
                        let aServerNum = a.server_number>>0;
                        let bServerNum = b.server_number>>0;

                        if (aServerNum > bServerNum){
                            return 1;
                        }
                        if (aServerNum < bServerNum) {
                            return -1;
                        }
                        return 0;
                    });

                    let sourceWorldInfo = res.login_info_world;
                    this.loginInfoWorld = [];
                    let subWorldInfo = [];
                    for (let tmpItem of sourceWorldInfo) {
                        tmpItem.server_maintenance = -1;
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoWorld.push(tmpItem);
                        } else {
                            subWorldInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subWorldInfo) {
                        this.loginInfoWorld.forEach(mainServer => {
                            if (tmpItem.combine_server_number === mainServer.server_number) {
                                mainServer.children.push(tmpItem);
                            }
                        })
                    }

                    this.loginInfoWorld.sort((a, b) => {
                        let aServerNum = a.server_order>>0;
                        let bServerNum = b.server_order>>0;

                        if (aServerNum > bServerNum) {
                            return 1;
                        }
                        if (aServerNum < bServerNum) {
                            return -1;
                        }
                        return 0;
                    });
                })
            },

            dotTipsPush(){
                let self = this;
                this.$confirm("此操作会给在线玩家一个邮件红点提示", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    self.resultShow = true;
                    self.resultArray = [];
                    self.loginInfoGame.forEach(reloadGameInfo => {
                        let balanceIpRecord = reloadGameInfo.inner_urls.split(';')[0];
                        self.resultArray.push({
                            server_url: balanceIpRecord,
                            server_name: reloadGameInfo.server_name,
                            resStatus: '0'
                        });
                        let dotPushForm = {
                            uri: balanceIpRecord,
                            hintId: 14,
                            record: '1'
                        }
                        gameApi.dotTipsPush({
                            token: self.token,
                            dotPushForm: dotPushForm
                        }).then(res => {
                            self.resultArray.forEach(resultItem => {
                                if (resultItem.server_url == dotPushForm.uri) {
                                    resultItem.resStatus = res.resStatus
                                }
                            })
                        })

                    })
                });
            },

            showGlobalMailDetail(globalMail) {
                let self = this;
                self.dialogData = globalMail;
                self.dialogData.contentDetail = JSON.parse(globalMail.content);
                self.dialogData.conditionJsonDetail = JSON.parse(globalMail.conditionJson);
                self.previewDateShow = true;
            },
            cancelGlobalMailDetailDialog() {
                let self = this;
                self.dialogData = {};
                self.previewDateShow = false;
            },
            modifyGlobalMail() {
                let self = this;
                this.$confirm('此操作将修改失效时间为（'+self.dialogData.gmtDisabled+'）, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let modifyForm = {
                        id: self.dialogData.id,
                        newDisableTime: self.dialogData.gmtDisabled,
                    }
                    mailApi.modifySystemMail({
                        token: self.token,
                        modifyForm: modifyForm
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        });
                        self.loadGlobalMail();
                        self.reloadAxiosAll(self.dialogData.server);
                        self.dialogData = {};
                        self.previewDateShow = false;
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            stopGlobalMail(rowData) {
                let self = this;
                let time = '';
                let timeZone = self.serverZoneTime;

                if (timeZone == -5) {
                    time = self.toWest5Time(new Date());
                } else if (timeZone == 8) {
                    time = self.toEast8Time(new Date());
                }

                time = Utils.formatDate(time);


                this.$confirm('全局邮件（'+rowData.uniqueId +'）会在（'+time+'）后停止发送, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let modifyForm = {
                        id: rowData.id,
                        newDisableTime: time,
                    }
                    mailApi.modifySystemMail({
                        token: self.token,
                        modifyForm: modifyForm
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        });
                        self.loadGlobalMail();
                        self.reloadAxiosAll(rowData.server);
                        self.dialogData = {};
                        self.previewDateShow = false;
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },

            // 获取邮件内容编辑器信息
            getMailContent(val) {
                this.langGroups = val;
            },
            getRewardsStr(val) {
                this.rewardsStr = val;
            },
            // 获取用户数据
            getUsersData(val) {
                var players = [];
                var triggerPlayers = [];
                val.forEach(item => {
                    players.push({
                        uri: item.uri,
                        serverId: item.server,
                        userId: item.id
                    })
                    triggerPlayers.push(item.id)
                })
                var serverArr = [];
                var serverStr = '';
                players.forEach(item2 => {
                    if (serverArr.indexOf(item2.serverId) == -1) {
                        serverArr.push(item2.serverId)
                    }
                })
                serverArr.forEach(item3 => {
                    serverStr = serverStr + (serverStr == '' ? '' : ',') + item3
                })

                this.playerServerStr = serverStr;
                // this.mailGlobalSendForm.triggerPlayers = players;
                this.mailGlobalSendForm.triggerPlayers = triggerPlayers;
            },

            getGameValue(val) {
                this.gameServerData = [];
                var serverStr = '';
                this.serverGameList.forEach(item => {
                    val.forEach(item2 => {
                        if (item.id == item2) {
                            serverStr = serverStr + (serverStr == '' ? '' : ',') + item.server_number;
                            this.gameServerData.push(item.server_number);
                        }
                    })
                })
                this.gameServerStr = serverStr;
            },

            // 渠道列表
            getChannelsList() {
                configSettingApi.channelList({
                    token: this.token
                }).then(res => {
                    this.channelData = res;
                })
            },

            // 添加条件
            addCustomLimit() {
                if (this.customLimitData.length < this.customLimitOptions.length) {
                    this.customLimitData.push([]);
                }
            },
            delCustomLimit(index) {
                this.customLimitOptions.forEach((item2,index2) => {
                    if (this.customLimitData[index].optionSelected == item2.value) {
                        this.customLimitSelectedOptions.splice(index,1);
                    }
                })

                this.customLimitData.splice(index,1);

            },
            optionChange() {
                var arr = [];
                this.customLimitData.forEach(item => {
                    this.customLimitOptions.forEach((item2,index2) => {
                        if (item.optionSelected == item2.value) {
                            arr.push(item2.value)
                        }
                    })
                })
                this.customLimitSelectedOptions = arr;
            },
            getCustomLimitDisable(value) {
                var self =  this;
                if (self.customLimitSelectedOptions.indexOf(value) >= 0) {
                    return true;
                } else {
                    return false;
                }
            },

            // 全服邮件
            sendGlobalMail() {
                let self = this;
                //let data = self.mailGlobalSendForm;
                self.mailGlobalSendForm.disableDays = self.endTime;
                self.mailGlobalSendForm.mailContents = self.langGroups;
                self.mailGlobalSendForm.rewards = self.rewardsStr;

                let conditionMap = {};
                self.customLimitData.forEach(item => {
                    if (item.channel) {
                        item.channel = item.channel.join(',');
                    }

                    if (item.userRegisterTime) {
                        item.userRegisterTime = item.userRegisterTime[0] + '_' + item.userRegisterTime[1];
                    }

                    delete item.optionSelected;
                    delete item.localUserRegisterTime;
                })
                for (var i in self.customLimitData) {
                    for (var j in self.customLimitData[i]) {
                        conditionMap[j] = self.customLimitData[i][j];
                    }
                }
                self.mailGlobalSendForm.conditionMap = conditionMap;
                if (self.mailGlobalSendForm.gmtStarted == '') {
                    self.$message({
                        type: 'warning',
                        message: '请填写起始时间!'
                    });
                    return;
                }

                if (self.mailGlobalSendForm.gmtDisabled == '') {
                    self.$message({
                        type: 'warning',
                        message: '请填写结束时间!'
                    });
                    return;
                }

                let currentServerArray = '0';

                if (self.selectMode == 'currentAll'){
                    let numberArray = [];
                    self.loginInfoGame.forEach(item=>{
                        numberArray.push(item.server_number);
                    })
                    currentServerArray = numberArray.join(",");
                }
                else if (self.selectMode == 'currentOpen'){
                    let numberOpenArray = [];
                    self.loginInfoGame.forEach(item=>{
                        if (item.server_load != 4 && item.server_load != 6){
                            numberOpenArray.push(item.server_number);
                        }
                    })
                    currentServerArray = numberOpenArray.join(",");
                }
                else if (self.selectMode == 'serverArray'){
                    currentServerArray = self.gameServerStr;
                }

                self.mailGlobalSendForm.server = currentServerArray;

                if (self.isOpenWhite) {
                    self.mailGlobalSendForm.status = '2';
                } else {
                    self.mailGlobalSendForm.status = '1';
                }

                mailApi.sendSystemMail({
                    token: self.token,
                    sendForm: self.mailGlobalSendForm
                }).then(res => {
                    self.$message({
                        type: 'success',
                        message: '发送成功'
                    });
                    self.postMailShow = false;
                    self.reloadAxiosAll(self.mailGlobalSendForm.server);
                    self.mailGlobalSendForm = {
                        disableDays: '',
                        mailContents: [],
                        conditionMap: [],
                        rewards: '',
                        status: '1',
                        server: '0',
                        gmtStarted: '',
                        gmtDisabled: ''
                    };


                })
            },

            showPostMail() {
                this.confirmSendMail = true;
                this.isSendSuccess = false;

                setTimeout(() => {
                    this.postMailShow = true;
                    this.confirmSendMail = false;
                    this.rewardsToCN(this.rewardsStr)
                },1000)

            },

            formatterRewardsToCN(rewards) {
                let resultArray = rewards.split(',');
                let result = '';
                resultArray.forEach(item => {
                    if (item !== '') {
                        this.resolveRewardStr(item);

                        let optionValueCN = this.optionMap[this.optionValue];
                        let idCn = this.getIdCn(this.optionValue,this.value);
                        let finalCount = '';
                        if (this.countSwitch) {
                            finalCount = this.count1 + "-" + this.count2;
                        } else {
                            finalCount = this.count1
                        }
                        let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;
                        result = result + (result?',':'') + finalContentCN;
                    }

                })

                return result;
            },

            rewardsToCN(rewards) {
                var arr = rewards.split(',');
                var result = '';
                arr.forEach(item => {
                    if (item !== '') {
                        this.resolveRewardStr(item);

                        let optionValueCN = this.optionMap[this.optionValue];
                        let idCn = this.getIdCn(this.optionValue,this.value);
                        let finalCount = '';
                        if (this.countSwitch) {
                            finalCount = this.count1 + "-" + this.count2;
                        } else {
                            finalCount = this.count1
                        }
                        let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;
                        result = result + (result?',':'') + finalContentCN;
                    }

                })

                this.rewardsStrCN = result;
            },

            resolveRewardStr(str){
                let self = this;

                if (str == '') {
                    self.countSwitch = false;
                    self.rateSwitch = false;
                    self.isDetail = false;
                    self.count1 = 1;
                    self.count2 = 1;
                    self.rate = 0.1;
                    self.emblemLevel = 1;
                    self.emblemStage = 0;
                    self.emblemQuality = 1;
                    self.emblemMainProperty = 1;
                    self.emblemFate = 0;
                    self.emblemFateCustomize = 100;
                    self.emblemFateProperty = 51;

                    self.editEmblemEntries = [
                        {
                            entry:[3, 0],
                            quality:0,
                            active:true
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                    ]
                }

                let rewardArray = str.toString().split("_");

                for (let index = 0; index < rewardArray.length; index++) {
                    const element = rewardArray[index];
                    switch (index) {
                        case 0:
                            let bigTypeArry = element.split("$");
                            //大类
                            self.optionValue = bigTypeArry[0];
                            //identify
                            self.value = parseInt(bigTypeArry[1]);
                            if (self.value == 50001) {
                                self.emblemRandomByQuality = false;
                            } else {
                                self.emblemRandomByQuality = true;
                            }
                            break;
                        case 1:
                            //数量
                            let countArry = element.split("-");
                            if(countArry.length>1){
                                self.countSwitch = true;
                                self.count1 = countArry[0];
                                let rateAndCount = countArry[1].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count2 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count2 = countArry[1];
                                }
                            }else{
                                self.countSwitch = false;

                                let rateAndCount = countArry[0].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count1 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count1 = countArry[0];
                                }
                            }
                            break;
                        case 2:
                            //等级
                            self.emblemLevel = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveQuality = parseInt(element);
                            }
                            break;
                        case 3:
                            //阶段
                            self.emblemStage = parseInt(element);

                            if (self.optionValue == '7') {
                                if (element) {
                                    self.warGrooveChannelSwitch = true;
                                    self.warGrooveChannelUp = parseInt(element);
                                } else {
                                    self.warGrooveChannelSwitch = false;
                                }
                            }
                            break;
                        case 4:
                            //品质
                            self.emblemQuality = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelDown = parseInt(element);
                            }
                            break;
                        case 5:
                            //宿命
                            let fateArray = element.split("#");
                            self.emblemFate = 3;
                            if(fateArray.length>1){
                                for (let i = 0; i < fateArray.length; i++) {
                                    const element = fateArray[i];
                                    let item = fateArray.splice("@");
                                    self.emblemFateCustomizeTags[i] = {id:parseInt(item[0]),chance:parseInt(item[1])}
                                }
                            }else{
                                if(element>0){
                                    self.emblemFate = 2;
                                    self.emblemFateProperty = parseInt(element);
                                }else{
                                    self.emblemFate = 0;
                                }
                            }

                            if (self.optionValue == '7') {
                                self.warGrooveChannelLeft = parseInt(element);
                            }

                            break;
                        case 6:
                            //宿命自定义概率
                            self.emblemFateCustomize = parseInt(element*100);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelRight = parseInt(element);
                            }
                            break;
                        case 7:
                            //主属性
                            self.emblemMainProperty = parseInt(element);
                            break;
                        case 8:
                            //词条属性
                            let entryArray = element.split("#");
                            for (let index = 0; index < entryArray.length; index++) {
                                const entryItem = entryArray[index];
                                let current = self.editEmblemEntries[index];

                                self.emblemEntryConfigs.forEach(item => {
                                    item.children.forEach(iitem => {
                                        if (iitem.value == entryArray[index].split('@')[0]&&entryArray[index].split('@').length>1) {
                                            self.editEmblemEntries[index].entry = [item.value,iitem.value];
                                            self.editEmblemEntries[index].active = true;
                                        } else {
                                            self.editEmblemEntries[index].active = false;
                                        }
                                    })
                                })

                                self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                            }

                            let countAndEntry = entryArray[entryArray.length-1].split('|');
                            if (countAndEntry.length>1) {
                                self.rateSwitch = true;
                                self.rate = countAndEntry[1];
                            } else {
                                self.rateSwitch = false;
                            }
                            break;
                        default:
                            break;
                    }
                }
            },

            getIdCn(optionValue,id){
                let self = this;
                if(optionValue == "1"){
                    //怪兽
                    return self.$t('monsterName_' + id);
                }else if(optionValue == "2"){
                    //怪兽碎片
                    return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
                }else if(optionValue == "6"){
                    //怪兽觉醒水晶
                    return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
                }else if(optionValue == "8"){
                    //怪兽觉醒水晶碎片
                    return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
                }else if(optionValue == "19"){
                    //怪兽觉醒水晶碎片
                    return self.$t('monsterName_' + ((id>>0)-70000)) + "的进化光谱";
                }else if(optionValue == "7"){
                    //战纹
                    return self.$t('warGrooveConfigName_' + id);
                }else{
                    //道具 0,3,4,5,9,10,11,12,13,14,15
                    return self.$t('propConfigName_'+id);
                }
            },

            // 重载游戏服
            reloadAxiosAll(serverids) {
                let self = this;
                self.resultShow = true;
                self.resultArray = [];
                let gameServerArray = serverids.split(",");

                let relationWorldId = [];
                self.loginInfoGame.forEach(loginInfoGameItem =>{
                    if (serverids == '0'){
                        self.reloadGameItem(loginInfoGameItem);
                    }else{
                        if (gameServerArray.indexOf(loginInfoGameItem.server_number) != -1){
                            self.reloadGameItem(loginInfoGameItem);
                            relationWorldId.push(loginInfoGameItem.world_id);
                        }
                    }
                })

                self.loginInfoWorld.forEach(loginInfoWorldItem =>{
                    if (serverids == '0'){
                        self.reloadWorldItem(loginInfoWorldItem);
                    }else{
                        if (relationWorldId.indexOf(loginInfoWorldItem.id) != -1){
                            self.reloadWorldItem(loginInfoWorldItem);
                        }
                    }
                })
            },

            /**
             * 重载单个游戏服
             * @param reloadGameInfo
             */
            reloadGameItem(reloadGameInfo){
                let self = this;
                let balanceIps = reloadGameInfo.inner_urls.split(';');
                balanceIps.forEach(item => {
                    if ('' != item) {
                        self.resultArray.push({
                            server_url: item,
                            server_name: reloadGameInfo.server_name,
                            resStatus: '0'
                        });
                        let reloadForm = {
                            uri: item,
                            type: 'game',
                            className: 'SystemMailConfig',
                            serverName: reloadGameInfo.server_name
                        }
                        gameApi.gameReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {
                            self.resultArray.forEach(resultItem => {
                                if (resultItem.server_url == reloadForm.uri) {
                                    resultItem.resStatus = res.resStatus
                                }
                            })
                        })
                    }
                })
            },

            /**
             * 重载单个战区
             * @param reloadWorldInfo
             */
            reloadWorldItem(reloadWorldInfo){
                let self = this;
                let balanceIps = reloadWorldInfo.inner_urls.split(';');
                balanceIps.forEach(item => {
                    if ('' != item) {
                        self.resultArray.push({
                            server_url: item,
                            server_name: reloadWorldInfo.server_name,
                            resStatus: '0'
                        });
                        let reloadForm = {
                            worldUri: item,
                            type: 'world',
                            className: 'SystemMailConfig',
                            serverName: reloadWorldInfo.server_name
                        }
                        worldApi.worldReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {
                            self.resultArray.forEach(resultItem => {
                                if (resultItem.server_url == reloadForm.worldUri) {
                                    resultItem.resStatus = res.resStatus
                                }
                            })
                        })
                    }
                })
            }
        },
        components: {
            mailEditor,
            componentQuery,
            componentServer
        }
    }
</script>

<style scoped lang="less">
    .el-card {
        margin: 5px 0 !important;
    }
    .reward-text {
        color: #5daf34;
    }

    .mail-tip {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/views/mails/global_mails.vue